<ng-container *ngIf="blockPage$ | async">
    <div class="page-blocker"></div>
</ng-container>


<ng-container *ngIf="loading$ | async">
    <div class="loading-indicator">
        <div class="row">
            <div class="col d-inline-flex">
                <span class="throbber"></span><div class="ps-2">{{ 'common.loading' | translate }}</div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="saving$ | async">
    <div class="saving-indicator">
        <div class="row">
            <div class="col d-inline-flex">
                <span class="throbber"></span><div class="ps-2">{{ 'common.saving' | translate }}</div>
            </div>
        </div>
    </div>
</ng-container>
